/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export interface AotCompilerOptions {
  debug?: boolean;
  locale?: string;
  i18nFormat?: string;
  translations?: string;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
